import type { SoldAddOn, SoldItem, SoldLines, SoldService } from '../types/agreements.types';

export interface InvoiceableService extends SoldService {
    partlyInvoiced: boolean;
}

export interface InvoiceableLines {
    services: InvoiceableService[];
    addOns: SoldAddOn[];
}

export const EVERYTHING_INVOICED_MESSAGE = 'Everything on this agreement has been invoiced.';

export const recordedItems = (service: SoldService): SoldItem[] =>
    service.items.filter((item) => item.placeholder !== true);

export function invoiceableLines(lines: SoldLines): InvoiceableLines {
    const services = lines.services.flatMap((service): InvoiceableService[] => {
        const items = service.items.filter((item) => item.status === 'available');
        if (items.length === 0) return [];
        return [{ ...service, items, partlyInvoiced: items.length < service.items.length }];
    });
    const addOns = lines.addOns.filter((addOn) => addOn.status === 'available');

    return { services, addOns };
}

export function isEverythingInvoiced(lines: SoldLines): boolean {
    const statuses = [...lines.services.flatMap((service) => service.items), ...lines.addOns].map(
        (line) => line.status,
    );
    return statuses.length > 0 && statuses.every((status) => status === 'claimed');
}

export function tableEmptyMessages(lines: SoldLines): { services: string; addOns: string } {
    return {
        services:
            lines.services.length === 0
                ? 'No sold services were recorded on this agreement.'
                : 'No services are left to invoice.',
        addOns:
            lines.addOns.length === 0
                ? 'No sold optional extras were recorded on this agreement.'
                : 'No optional extras are left to invoice.',
    };
}
